/**
 * ISO 3166-1 alpha-2 → flag emoji (display only).
 */
export function countryFlagEmoji(countryCode) {
  const code = String(countryCode || "XX").toUpperCase();
  if (!code || code === "XX" || code.length !== 2) return "🌐";
  return code
    .split("")
    .map((char) => String.fromCodePoint(127397 + char.charCodeAt(0)))
    .join("");
}

export function formatCountryRow(country) {
  return {
    country: country?.country || "Unknown",
    countryCode: country?.countryCode || "XX",
    visitors: Number(country?.visitors) || 0,
    events: Number(country?.events) || 0,
    flag: countryFlagEmoji(country?.countryCode),
  };
}

export function mergeTopCountries(countries = []) {
  const byCode = new Map();
  for (const row of countries) {
    const code = String(row.countryCode || row.country_code || "XX").toUpperCase();
    const existing = byCode.get(code);
    if (!existing) {
      byCode.set(code, {
        country: row.country || "Unknown",
        countryCode: code,
        visitors: Number(row.visitors) || 0,
        events: Number(row.events) || 0,
        percentage: row.percentage != null ? Number(row.percentage) : null,
      });
      continue;
    }
    existing.visitors += Number(row.visitors) || 0;
    existing.events += Number(row.events) || 0;
  }
  const merged = [...byCode.values()];
  const totalVisitors = merged.reduce((sum, row) => sum + row.visitors, 0);
  return merged
    .map((row) => ({
      ...row,
      percentage:
        row.percentage != null && byCode.size === countries.length
          ? row.percentage
          : totalVisitors > 0
            ? Math.round((row.visitors / totalVisitors) * 1000) / 10
            : 0,
    }))
    .sort((a, b) => b.visitors - a.visitors);
}
